export default "__VITE_ASSET__56f1b8ba__"